import http from '../http';

export type SexType = 'MALE' | 'FEMALE' | 'UNKNOWN';
export interface BaristaModel {
  id: string;
  name: string;
  nickname: string;
  cpf: string;
  sexType: SexType;
  city: string;
  phone: string;
  startDate: Date;
  birth: Date;
  image: string;
}

export interface BaristaPayload {
  name: string;
  nickname: string;
  cpf: string;
  sexType: SexType;
  city: string;
  phone: string;
  startDate: Date;
  birth: Date;
}

export const barista = {
  list: async () => {
    const { status, data: result } = await http.get<BaristaModel[]>('/v3/kds/quiz/list/barista');

    if (status !== 200) {
      throw new Error((result as any).message);
    }
    return result;
  },
  add: async ({ data, files }: { data: BaristaPayload; files: File | null }) => {
    const formData = new FormData();

    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));

    if (files) {
      formData.append('files', files);
    }

    const { status, data: result } = await http.post('v3/kds/quiz/barista', formData);

    if (status !== 200) {
      throw new Error((result as any).message);
    }

    return result;
  },
};
